import { render, staticRenderFns } from "./afterPaymentPaymentInInstallments.vue?vue&type=template&id=6c61ab04&scoped=true&"
import script from "./afterPaymentPaymentInInstallments.vue?vue&type=script&lang=js&"
export * from "./afterPaymentPaymentInInstallments.vue?vue&type=script&lang=js&"
import style0 from "./afterPaymentPaymentInInstallments.vue?vue&type=style&index=0&id=6c61ab04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61ab04",
  null
  
)

export default component.exports